import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui: łączenie klas z rozwiązywaniem konfliktów Tailwinda. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
